<template>
  <CollapseFilters ref="collapse">
    <Form ref="form" @submit.prevent>
      <div class="row g-4">
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataInicialDeExpiracao") }}</label>
          <DateInput v-model="filters.expiradaEmInicial" :required="filters.expiradaEmFinal !== ''" />
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataFinalDeExpiracao") }}</label>
          <DateInput v-model="filters.expiradaEmFinal" :required="filters.expiradaEmInicial !== ''" />
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataInicialCadastro") }}</label>
          <DateInput v-model="filters.dataCadastroInicial" :required="filters.dataCadastroFinal !== ''" />
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataFinalCadastro") }}</label>
          <DateInput v-model="filters.dataCadastroFinal" :required="filters.dataCadastroInicial !== ''" />
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataUltimaRenovacaoInicial") }}</label>
          <DateInput v-model="filters.ultimaRenovacaoInicial" :required="filters.ultimaRenovacaoFinal !== ''" />
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataUltimaRenovacaoFinal") }}</label>
          <DateInput v-model="filters.ultimaRenovacaoFinal" :required="filters.ultimaRenovacaoInicial !== ''" />
        </div>
        <div class="col-lg-6 col-md-6">
          <label class="form-label">{{ $t("pesquisar") }}</label>
          <input v-model="filters.search" type="text" class="form-control" maxlength="64">
        </div>
      </div>
      <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
        <LoadingButton class="btn-primary" :loading="loading" @click="onClick">
          <i class="bi bi-filter" /> {{ $t("filtrar") }}
        </LoadingButton>
      </div>
    </Form>
  </CollapseFilters>
</template>

<script>
import CollapseFilters from '@/modules/shared/components/CollapseFilters.vue';
import Form from '@/modules/core/components/FormInput.vue';
import DateInput from '@/modules/core/components/DateInput.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { useToast } from 'vue-toastification';
import { toISO } from '@/modules/core/utils/formats';

export default {
  components: { CollapseFilters, Form, DateInput, LoadingButton },
  props: {
    loading: { type: Boolean, required: true },
  },
  emits: ['filter'],
  data: () => ({
    filters: {
      expiradaEmInicial: '',
      expiradaEmFinal: '',
      search: '',
      dataCadastroInicial: '',
      dataCadastroFinal: '',
      ultimaRenovacaoInicial: '',
      ultimaRenovacaoFinal: '',
    },
  }),
  mounted() { this.$emit('filter', this.filters); },
  methods: {
    onClick() {
      if (this.validateDate()) {
        if (this.$refs.form.validate()) {
          this.$emit('filter', this.filters);
          this.$refs.collapse.toggle();
        }
      }
    },
    validateDate() {
      if (this.filters.expiradaEmInicial !== '') {
        if (new Date(toISO(this.filters.expiradaEmInicial)) > new Date(toISO(this.filters.expiradaEmFinal))) {
          useToast().error(this.$t('dataInicialExpiracaoSuperiorAFinal'));
          return false;
        }
      }
      if (this.filters.dataCadastroInicial !== '') {
        if (new Date(toISO(this.filters.dataCadastroInicial)) > new Date(toISO(this.filters.dataCadastroFinal))) {
          useToast().error(this.$t('dataInicialCadastroSuperiorAFinal'));
          return false;
        }
      }
      if (this.filters.ultimaRenovacaoInicial !== '') {
        if (new Date(toISO(this.filters.ultimaRenovacaoInicial)) > new Date(toISO(this.filters.ultimaRenovacaoFinal))) {
          useToast().error(this.$t('dataInicialRenovacaoSuperiorAFinal'));
          return false;
        }
      }
      return true;
    },
  },
};

</script>
